import GlobeIcon from "@redotech/redo-icons/globe-02.svg";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./locale-selector.module.css";
import { ALL_LOCALES, LOCALE_NAMES } from "./locales";

export const LocaleSelector = memo(function LocaleSelector() {
  const { t, i18n } = useTranslation();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      void i18n.changeLanguage(e.target.value);
    },
    [i18n],
  );

  return (
    <div className={styles.container}>
      <div className={styles.button}>
        <GlobeIcon className={styles.icon} height={16} width={16} />
      </div>
      <select
        aria-label={t("Select language")}
        className={styles.select}
        onChange={handleChange}
        value={i18n.language}
      >
        {ALL_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {LOCALE_NAMES[locale]}
          </option>
        ))}
      </select>
    </div>
  );
});
